export  enum CriticalityEnum {
    NOT_USED = "NOT_USED",
    USED = "USED",
    BENEFICIAL = "BENEFICIAL",
    IMPORTANT = "IMPORTANT",
    CRITICAL = "CRITICAL",
    NIS = "NIS"
}